import LegalPage from './index'
import styles from './style.module.scss'

/* Inhaltlich massgeblich: Junior/rechtstexte/datenschutzerklaerung.md (Stand Juli 2026). */
export default function Datenschutz() {
	return (
		<LegalPage title="Datenschutzerklärung" stand="August 2026">
			<p>
				Der Schutz Ihrer personenbezogenen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten
				ausschließlich auf Grundlage der gesetzlichen Bestimmungen (Datenschutz-Grundverordnung — DSGVO,
				österreichisches Datenschutzgesetz — DSG, Telekommunikationsgesetz 2021 — TKG). In dieser
				Datenschutzerklärung informieren wir Sie über die Verarbeitung personenbezogener Daten im Rahmen der
				Plattform „Junior Datenbank" (<a href="https://company.junior.cc">company.junior.cc</a>).
			</p>

			<h2>1. Verantwortlicher</h2>
			<address className={styles.address}>
				<strong>„Junior Achievement Austria" – Unternehmerische Praxis- und Kompetenzbildung</strong>
				<br />
				Heinrichsgasse 3/1/Top 8+9, 1010 Wien, Österreich
				<br />
				Telefon: <a href="tel:+4367684171755">+43 676 841 717 55</a> · E-Mail:{' '}
				<a href="mailto:info@junior.cc">info@junior.cc</a>
				<br />
				ZVR-Zahl: 252077520
			</address>
			<p>
				Datenschutzanfragen richten Sie bitte an: <a href="mailto:info@junior.cc">info@junior.cc</a>
			</p>

			<h2>2. Auftragsverarbeiter</h2>
			<p>Wir setzen für den Betrieb der Plattform folgende Auftragsverarbeiter im Sinne von Art. 28 DSGVO ein:</p>
			<div className={styles.tableWrapper}>
				<table className={styles.table}>
					<thead>
						<tr>
							<th>Auftragsverarbeiter</th>
							<th>Zweck</th>
							<th>Standort</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>DaVinciLab GmbH, Poschgasse 3/51, 1140 Wien</td>
							<td>Technische Entwicklung, Betrieb und Wartung der Plattform</td>
							<td>Österreich</td>
						</tr>
						<tr>
							<td>Amazon Web Services EMEA SARL (AWS)</td>
							<td>Hosting (Server und Datenbank), Region eu-central-1 (Frankfurt am Main)</td>
							<td>Deutschland / EU</td>
						</tr>
					</tbody>
				</table>
			</div>
			<p>Eine Übermittlung personenbezogener Daten in Drittländer außerhalb der EU/des EWR findet nicht statt.</p>

			<h2>3. Zweck der Plattform und betroffene Personengruppen</h2>
			<p>
				Die Junior Datenbank dient der Verwaltung der JA Austria Programme: der Registrierung und Verwaltung von
				Schülerfirmen, der Erstellung von Halbjahres- und Jahresberichten, der Verwaltung von Dokumenten und
				Urkunden, der Vermittlung von Unterstützer:innen (Wirtschaftsexpert:innen, Jurymitglieder,
				Trainer:innen) sowie der Kommunikation zwischen den Beteiligten.
			</p>
			<p>Betroffene Personengruppen sind:</p>
			<ul>
				<li>Schüler:innen (Mitarbeiter:innen der Junior Companies, überwiegend Minderjährige)</li>
				<li>Lehrkräfte (betreuende Lehrer:innen)</li>
				<li>Administrator:innen (Landes- und Bundesebene)</li>
				<li>Unterstützer:innen (Expert:innen, Jurymitglieder, Trainer:innen)</li>
				<li>Anteilseigner:innen der Schülerfirmen (häufig Angehörige der Schüler:innen)</li>
				<li>Eingeladene Personen (vor Abschluss der Registrierung)</li>
			</ul>

			<h2>4. Welche Daten wir verarbeiten</h2>
			<h3>4.1 Konto- und Profildaten (alle Nutzer:innen)</h3>
			<p>
				Rolle, Anrede, Geschlecht, Titel, Vor- und Nachname, E-Mail-Adresse, Passwort (verschlüsselt
				gespeichert), Geburtsdatum, Telefonnummer, Adresse (Straße, Hausnummer, PLZ, Ort, Bundesland),
				Profilfoto (optional), Zuordnung zu Schule und/oder Schülerfirma, Kontostatus, Registrierungs- und
				Bestätigungsdaten (z. B. E-Mail-Bestätigung), Einstellungs- und Anzeigepräferenzen.
			</p>
			<h3>4.2 Schüler:innen</h3>
			<p>
				Zusätzlich: Funktion in der Schülerfirma (z. B. Geschäftsführung), Bestätigung der
				Erziehungsberechtigten (hochgeladenes Dokument), Kurszertifikate, Teilnahmebestätigungen und Urkunden.
			</p>
			<h3>4.3 Lehrkräfte</h3>
			<p>
				Zusätzlich: Verifizierungsstatus, betreute Schülerfirmen, Schulzuordnung. <strong>Hinweis:</strong>{' '}
				Vor- und Nachname der betreuenden Lehrkraft werden gemeinsam mit der Schule auf der öffentlichen
				Firmenübersicht der Plattform angezeigt (siehe Punkt 7).
			</p>
			<h3>4.4 Unterstützer:innen (Expert:innen, Jury, Trainer:innen)</h3>
			<p>
				Zusätzlich: Unternehmen, Position, Website, LinkedIn-Profil, Kurzbeschreibung (Bio),
				Fachgebiete/Spezialisierungen, Regionen und Einsatzbereiche, Verfügbarkeitsstatus, bevorzugte
				Kontaktarten und Kontakthinweise, Zeitpunkt der DSGVO-Einwilligung, Freigabedaten. Für Schulen und
				Schüler:innen sichtbar sind ausschließlich freigegebene, aktive Expert:innen — und zwar ohne private
				Kontaktdaten.
			</p>
			<h3>4.5 Anteilseigner:innen</h3>
			<p>
				Anrede, Titel, Vor- und Nachname, Adresse, E-Mail-Adresse, Telefonnummer, Geschlecht, Geschäftsanteil,
				hochgeladene Einwilligungserklärung.
			</p>
			<h3>4.6 Schülerfirmen-Daten</h3>
			<p>
				Firmenname, Firmentyp, Bundesland, Kontaktdaten der Firma, Branche, Geschäftsidee und -beschreibung,
				Social-Media- und Website-Links, Logo, Halbjahres- und Jahresberichte mit Finanzdaten (Umsätze,
				Aufwände, Gehälter, Sozialversicherungsbeiträge, Lohnsteuer, Umsatzsteuer, Gewinn/Verlust), Rechnungen,
				Versicherungsdaten, Geschäftspläne und sonstige Dokumente.
			</p>
			<h3>4.7 Support und Kommunikation</h3>
			<p>
				Anfragen und Tickets samt Kommentaren und hochgeladenen Screenshots, Systembenachrichtigungen,
				Einladungen (E-Mail-Adresse und Rolle eingeladener Personen), Unterstützungsanfragen und Rückmeldungen
				dazu.
			</p>
			<h3>4.8 Technische Daten</h3>
			<p>
				Beim Aufruf der Plattform verarbeitet der Webserver technisch bedingt Verbindungsdaten (IP-Adresse,
				Datum und Uhrzeit, aufgerufene Ressource bzw. URL, übertragene Datenmenge, Browsertyp und -version,
				Betriebssystem, Referrer-URL) in Server-Logs. Diese Daten dienen der Sicherstellung der
				Funktionsfähigkeit, Stabilität und Sicherheit des Betriebs (Rechtsgrundlage: Art. 6 Abs. 1 lit. f
				DSGVO) und werden nicht mit anderen Datenquellen zusammengeführt. Eine Auswertung der IP-Adressen
				erfolgt nur im Fall von Angriffen auf unsere Systeme. Die Log-Daten werden automatisiert gelöscht,
				sobald sie für die genannten Zwecke nicht mehr benötigt werden, spätestens jedoch nach 30 Tagen.
			</p>
			<h3>4.9 Kontaktaufnahme</h3>
			<p>
				Wenn Sie uns per E-Mail oder Telefon kontaktieren (z. B. an{' '}
				<a href="mailto:info@junior.cc">info@junior.cc</a> oder eine der Landes-Adressen), verarbeiten wir
				Anrede, Name, E-Mail-Adresse, Telefonnummer, Betreff und den Inhalt Ihrer Nachricht sowie allfällige
				technische Übertragungsdaten. Rechtsgrundlage sind unsere berechtigten Interessen an der Beantwortung
				Ihres Anliegens (Art. 6 Abs. 1 lit. f DSGVO) bzw. vorvertragliche Maßnahmen (Art. 6 Abs. 1 lit. b
				DSGVO). Diese Daten werden grundsätzlich nach sechs Monaten gelöscht, sofern nicht ein laufendes
				Vertrags- bzw. Teilnahmeverhältnis, gesetzliche Aufbewahrungspflichten oder überwiegende berechtigte
				Interessen eine längere Speicherung erfordern.
			</p>

			<h2>5. Zwecke und Rechtsgrundlagen der Verarbeitung</h2>
			<div className={styles.tableWrapper}>
				<table className={styles.table}>
					<thead>
						<tr>
							<th>Verarbeitung</th>
							<th>Zweck</th>
							<th>Rechtsgrundlage</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Konto, Profil, Firmenverwaltung, Berichte, Dokumente</td>
							<td>Teilnahme am Junior-Programm, Bereitstellung der Plattformfunktionen</td>
							<td>Art. 6 Abs. 1 lit. b DSGVO (Vertrag/vorvertragliche Maßnahmen)</td>
						</tr>
						<tr>
							<td>Registrierung von Unterstützer:innen</td>
							<td>Vermittlung von Expert:innen, Jury, Trainer:innen</td>
							<td>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung, wird bei Registrierung eingeholt und protokolliert)</td>
						</tr>
						<tr>
							<td>Verarbeitung von Daten Minderjähriger</td>
							<td>Programmteilnahme</td>
							<td>
								Art. 6 Abs. 1 lit. b DSGVO; bei einwilligungsbasierten Verarbeitungen unter 14 Jahren
								Einwilligung der Erziehungsberechtigten (Art. 8 DSGVO i.V.m. § 4 Abs. 4 DSG);
								Elternbestätigung wird als Dokument eingeholt
							</td>
						</tr>
						<tr>
							<td>E-Mail-Versand (Bestätigungen, Einladungen, Passwort-Zurücksetzung, Erinnerungen, Systembenachrichtigungen)</td>
							<td>Betrieb der Plattform, Information der Nutzer:innen</td>
							<td>Art. 6 Abs. 1 lit. b DSGVO</td>
						</tr>
						<tr>
							<td>Information über eigene, ähnliche Programme und Angebote per E-Mail (siehe Punkt 9)</td>
							<td>Direktwerbung für eigene Programme</td>
							<td>
								Art. 6 Abs. 1 lit. f DSGVO i.V.m. § 174 Abs. 4 TKG 2021 (Widerspruch jederzeit möglich)
							</td>
						</tr>
						<tr>
							<td>Öffentliche Firmenpräsentation (siehe Punkt 7)</td>
							<td>Präsentation der Junior Companies, Vereinszweck</td>
							<td>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) bzw. lit. a (Einwilligung)</td>
						</tr>
						<tr>
							<td>Server-Logs, Sicherheit, Missbrauchsvermeidung</td>
							<td>Betriebssicherheit</td>
							<td>Art. 6 Abs. 1 lit. f DSGVO</td>
						</tr>
						<tr>
							<td>Aufbewahrung von Berichts-, Rechnungs- und Versicherungsdaten</td>
							<td>Erfüllung gesetzlicher Pflichten</td>
							<td>Art. 6 Abs. 1 lit. c DSGVO</td>
						</tr>
					</tbody>
				</table>
			</div>

			<h2>6. Registrierung und Konten</h2>
			<p>
				Schüler:innen und Lehrkräfte können sich selbst registrieren (mit E-Mail-Bestätigung per
				Doppel-Opt-in). Konten können außerdem durch Einladung (durch Schülerfirmen, Lehrkräfte oder
				Administrator:innen) angelegt werden; in diesem Fall speichern wir die E-Mail-Adresse und vorgesehene
				Rolle der eingeladenen Person bereits vor Abschluss der Registrierung. Unterstützer:innen registrieren
				sich über eine öffentliche Registrierungsseite oder auf Einladung; ihre Profile werden erst nach
				Prüfung und Freigabe durch die Programmadministration aktiv.
			</p>

			<h2>7. Öffentlich sichtbare Daten</h2>
			<p>
				Auf der öffentlich (ohne Anmeldung) erreichbaren Startseite der Plattform werden Junior Companies
				präsentiert. Dabei sind sichtbar: Firmenname, Firmentyp, Bundesland, Schule, Branche,
				Geschäftsidee/-beschreibung, Logo sowie Vor- und Nachname der betreuenden Lehrkraft. Personenbezogene
				Daten von Schüler:innen werden auf der öffentlichen Startseite nicht angezeigt. Lehrkräfte, die mit der
				öffentlichen Nennung ihres Namens nicht einverstanden sind, können sich an{' '}
				<a href="mailto:info@junior.cc">info@junior.cc</a> wenden.
			</p>

			<h2>8. Empfänger der Daten</h2>
			<p>
				Innerhalb der Plattform gilt ein rollenbasiertes Berechtigungssystem: Schüler:innen und Lehrkräfte
				sehen die Daten ihrer eigenen Schülerfirma bzw. der von ihnen betreuten Firmen; Landesadministrator:innen
				die Daten ihres Bundeslands; Bundesadministrator:innen alle Daten. Unterstützer:innen-Profile sind für
				Schulen nur in freigegebener Form ohne private Kontaktdaten sichtbar.
			</p>
			<p>
				Eine Weitergabe an Dritte außerhalb der Plattform erfolgt nur, wenn eine gesetzliche Verpflichtung
				besteht oder Sie ausdrücklich eingewilligt haben. An den Versicherer der Junior Companies werden im
				laufenden Programmbetrieb <strong>keine</strong> personenbezogenen Daten übermittelt. Nur wenn ein
				Versicherungsfall eintritt, ist die Weitergabe der dafür erforderlichen Daten nötig — dafür holen wir
				vorab Ihre ausdrückliche Einwilligung ein. Ein Verkauf von Daten findet nicht statt.
			</p>

			<h2>9. Information über Programme und Angebote (Direktwerbung)</h2>
			<p>
				Im Zusammenhang mit Ihrer Teilnahme an unseren Programmen nutzen wir Ihre E-Mail-Adresse, um Sie über
				eigene, ähnliche Programme und Angebote von Junior Achievement Austria zu informieren. In der Regel
				sind das Einladungen zu Ausschreibungen (z. B. Bewerbungen um Sonderawards), die inhaltlich zur
				jeweiligen Junior Company passen. Diese Nachrichten versenden wir selbst aus unserem eigenen
				E-Mail-Postfach; ein externes Newsletter- oder Werbewerkzeug setzen wir dafür nicht ein, und Ihre
				E-Mail-Adresse wird zu diesem Zweck nicht an Dritte weitergegeben. Rechtsgrundlage sind unsere
				berechtigten Interessen (Art. 6 Abs. 1 lit. f DSGVO) in Verbindung mit § 174 Abs. 4 TKG 2021.
			</p>
			<p>
				Sie können dem Erhalt solcher Nachrichten jederzeit mit Wirkung für die Zukunft widersprechen — formlos
				durch Antwort auf die jeweilige Nachricht oder per Mitteilung an{' '}
				<a href="mailto:info@junior.cc">info@junior.cc</a>. Es entstehen Ihnen dafür keine Kosten außer den
				Übermittlungskosten nach den Basistarifen. E-Mails, die für den Betrieb der Plattform und Ihre
				Programmteilnahme nötig sind (z. B. Bestätigungen, Einladungen, Erinnerungen und
				Systembenachrichtigungen), erhalten Sie unabhängig davon weiter.
			</p>

			<h2>10. Cookies und lokale Speicherung</h2>
			<p>
				Die Plattform verwendet <strong>keine Cookies</strong> und{' '}
				<strong>keine Analyse-, Tracking- oder Werbedienste</strong>.
			</p>
			<p>
				Im lokalen Speicher Ihres Browsers (localStorage) werden ausschließlich technisch notwendige Einträge
				abgelegt:
			</p>
			<div className={styles.tableWrapper}>
				<table className={styles.table}>
					<thead>
						<tr>
							<th>Eintrag</th>
							<th>Zweck</th>
							<th>Speicherdauer</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>auth</td>
							<td>Anmelde-Token (JWT), hält Ihre Sitzung aufrecht</td>
							<td>bis zur Abmeldung, Token max. 60 Tage gültig</td>
						</tr>
						<tr>
							<td>i18nextLng</td>
							<td>Ihre Sprachwahl (Deutsch/Englisch)</td>
							<td>bis zur Löschung durch Sie</td>
						</tr>
						<tr>
							<td>privacyNoticeDismissed</td>
							<td>Merkt sich, dass Sie den Datenschutzhinweis geschlossen haben</td>
							<td>bis zur Löschung durch Sie</td>
						</tr>
					</tbody>
				</table>
			</div>
			<p>
				Diese Speicherung ist für die Bereitstellung des Dienstes unbedingt erforderlich (§ 165 Abs. 3 TKG
				2021); eine Einwilligung ist dafür nicht notwendig. Sie können die Einträge jederzeit über die
				Browser-Einstellungen löschen.
			</p>

			<h2>11. Schriftarten und externe Dienste</h2>
			<p>
				Die auf der Plattform verwendeten Schriftarten („Poppins", „Work Sans") werden lokal auf unseren
				eigenen Servern gehostet. Beim Aufruf der Plattform wird keine Verbindung zu Servern von Google (Google
				Fonts) oder anderen Drittanbietern aufgebaut; es werden keine Inhalte von externen
				Content-Delivery-Netzwerken nachgeladen.
			</p>

			<h2>12. Speicherdauer und Löschung</h2>
			<ul>
				<li>
					<strong>Schüler:innen-Konten und Junior Companies:</strong> Am Ende jedes Schuljahrs werden die
					Junior Companies samt zugehörigen Dokumenten sowie die Konten der Schüler:innen im Rahmen des
					jährlichen Datenbank-Resets gelöscht.
				</li>
				<li>
					<strong>
						Konten von Lehrkräften, Administrator:innen und Unterstützer:innen sowie Schulstammdaten
					</strong>{' '}
					bleiben über das Schuljahr hinaus erhalten, solange das jeweilige Konto besteht.
				</li>
				<li>
					<strong>Sicherung zum Jahresreset:</strong> Unmittelbar vor dem Löschen erzeugt die Plattform eine
					Export-Datei (Tabellenkalkulation) mit den Stamm- und Verwaltungsdaten der betroffenen Nutzer:innen
					und Junior Companies. Sie dient Nachweiszwecken und der Erfüllung gesetzlicher
					Aufbewahrungspflichten, ist ausschließlich für Bundesadministrator:innen abrufbar und wird auf der
					Plattform beim nächsten Jahresreset überschrieben; die weitere Aufbewahrung erfolgt außerhalb der
					Plattform beim Verantwortlichen. Erzeugte Dokumente (z. B. Urkunden, Berichte und Rechnungen als
					Datei) sind nicht Teil dieser Sicherung — Nutzer:innen sind selbst dafür verantwortlich, benötigte
					Unterlagen rechtzeitig vor dem Reset herunterzuladen.
				</li>
				<li>
					<strong>Unterstützer:innen:</strong> Auf Wunsch (Widerruf der Einwilligung im Profil oder Antrag)
					werden Profile anonymisiert — Name, E-Mail-Adresse, Telefonnummer, Adresse, Kurzbeschreibung und
					Profilfoto werden entfernt. Das zugehörige Benutzerkonto wird dabei gesperrt: Eine Anmeldung ist
					danach nicht mehr möglich. Der anonyme Datensatz bleibt bestehen, damit die Historie der Junior
					Companies vollständig bleibt.
				</li>
				<li>
					<strong>Berichte, Rechnungen, Versicherungs- und Abrechnungsdaten</strong> werden aufbewahrt,
					solange gesetzliche Aufbewahrungspflichten (insb. § 132 BAO: sieben Jahre) dies erfordern. Die dafür
					maßgeblichen Daten gehen vor dem Jahresreset in die oben genannte Sicherung ein; die Datensätze in
					der Plattform selbst werden mit dem Reset gelöscht.
				</li>
				<li>
					<strong>Server-Protokolle</strong> (Punkt 4.8) werden gelöscht, sobald sie für Betrieb und
					Sicherheit nicht mehr benötigt werden, längstens nach 30 Tagen.
				</li>
				<li>
					<strong>E-Mail- und Telefonanfragen</strong> an uns (Punkt 4.9) werden grundsätzlich nach sechs
					Monaten gelöscht.
				</li>
				<li>
					<strong>E-Mail-Bestätigungs- und Einladungslinks</strong> sind zeitlich begrenzt gültig (längstens
					60 Tage).
				</li>
			</ul>
			<p>
				Darüber hinaus speichern wir personenbezogene Daten nur so lange, wie es für die genannten Zwecke
				erforderlich ist.
			</p>

			<h2>13. Datensicherheit</h2>
			<p>
				Die Übertragung zur Plattform erfolgt verschlüsselt (HTTPS/TLS). Passwörter werden ausschließlich als
				kryptografische Prüfsumme gespeichert. Der Zugriff auf Daten ist durch ein rollenbasiertes
				Berechtigungssystem beschränkt; der administrative Serverzugriff erfolgt über abgesicherte
				Verwaltungszugänge ohne offene Fernwartungsports. Hochgeladene Dokumente sind nur für berechtigte
				Nutzer:innen abrufbar.
			</p>

			<h2>14. Ihre Rechte</h2>
			<p>
				Ihnen stehen grundsätzlich die Rechte auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung
				(Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch
				(Art. 21) zu. Eine erteilte Einwilligung können Sie jederzeit widerrufen; die Rechtmäßigkeit der bis
				zum Widerruf erfolgten Verarbeitung bleibt davon unberührt.
			</p>
			<p>
				Unterstützer:innen (Expert:innen, Jury, Trainer:innen) können ihre bei der Registrierung erteilte
				Einwilligung unmittelbar in der Plattform widerrufen: im eigenen Profil unter „Einwilligung“. Mit dem
				Widerruf wird das Profil gelöscht, die personenbezogenen Daten werden anonymisiert, offene Anfragen
				beendet und der Zugang zur Plattform beendet; eine Bestätigung geht per E-Mail an die zuletzt
				hinterlegte Adresse. Wer später wieder als Unterstützer:in zur Verfügung stehen möchte, registriert
				sich neu. Alternativ genügt eine Nachricht an <a href="mailto:info@junior.cc">info@junior.cc</a>.
			</p>
			<p>
				Zur Ausübung Ihrer Rechte wenden Sie sich an <a href="mailto:info@junior.cc">info@junior.cc</a>. Bei
				Minderjährigen können die Rechte auch durch die Erziehungsberechtigten ausgeübt werden.
			</p>
			<p>
				Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt, haben
				Sie das Recht auf Beschwerde bei der Aufsichtsbehörde:
			</p>
			<address className={styles.address}>
				<strong>Österreichische Datenschutzbehörde</strong>
				<br />
				Barichgasse 40–42, 1030 Wien
				<br />
				Telefon: +43 1 52 152-0 · E-Mail: <a href="mailto:dsb@dsb.gv.at">dsb@dsb.gv.at</a> · Web:{' '}
				<a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer">
					www.dsb.gv.at
				</a>
			</address>

			<h2>15. Änderungen dieser Datenschutzerklärung</h2>
			<p>
				Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich die Rechtslage, die Plattform
				oder die Datenverarbeitung ändert. Es gilt die jeweils auf der Plattform veröffentlichte Fassung.
			</p>
		</LegalPage>
	)
}
